import { Component } from 'shimmer'

import { VirtualScroll } from '@/utils/VirtualScroll'
import { clamp } from '@/utils/Maths'

import { Vector3, AnimationMixer } from 'three'

const factorScroll = 1000
const factorPointerPos = .2

export class CameraAnimation extends Component {
  constructor (camera, animationClip) {
    super()

    this.onScroll = this.onScroll.bind(this)

    this.camera = camera
    this.animationClip = animationClip
    this.mixer = new AnimationMixer(this.camera)
    this.action = this.mixer.clipAction(this.animationClip)
    this.action.play()

    this.scroll = new VirtualScroll({ smooth: .05, clamp: { min: 0, max: this.animationClip.duration * factorScroll} })
    this.scroll.onSmoothScroll(this.onScroll)

    this.progress = 0
    this.rotate = {
      x: 0,
      y: 0
    }

    this.pointer = {x: 0, y:0}
  }

  onScroll ({ progress }) {
    this.progress = progress
  }

  onUpdate () {
    // if set time is not used to set  new time
    // camera position won't be updated
    // soi we set a small random value to prevent that
    this.mixer.setTime(this.progress * this.animationClip.duration + Math.random()*.00000001)

    let rotate = {
      x: -this.pointer.x * factorPointerPos,
      y: this.pointer.y * factorPointerPos
    }

    this.camera.rotateY(-this.pointer.x * factorPointerPos)
    this.camera.rotateX(this.pointer.y * factorPointerPos)
  }

  set pointerPosition (value) {
    this.pointer = value
  }

  get active () {
    return this.isActive
  }

  set active (value) {
    this.isActive = value
  }
}